var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingSel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_399_242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 14.6667C4.98267 14.6667 4.63933 14.524 4.39067 14.276L0.390667 10.276C0.142667 10.0273 0 9.684 0 9.33333C0 8.98267 0.142667 8.63933 0.390667 8.39067L6.39067 2.39067C6.63933 2.14267 6.98267 2 7.33333 2H11.3333C11.4193 2 11.5007 2.01 11.5807 2.03C12.1873 2.12267 12.6667 2.68533 12.6667 3.33333V7.33333C12.6667 7.684 12.524 8.02733 12.276 8.276L6.276 14.276C6.02733 14.524 5.684 14.6667 5.33333 14.6667ZM7.33333 2.66667C7.158 2.66667 6.98667 2.738 6.862 2.862L0.862 8.862C0.738 8.98667 0.666667 9.158 0.666667 9.33333C0.666667 9.50867 0.738 9.68 0.862 9.80467L4.862 13.8047C5.11067 14.0533 5.55533 14.0533 5.804 13.8047L11.804 7.80467C11.9287 7.68 12 7.50867 12 7.33333V3.33333C12 3.01133 11.7633 2.73133 11.4487 2.68267C11.3913 2.66933 11.3653 2.66667 11.3333 2.66667H7.33333Z",
    fill: "url(#paint0_linear_399_242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 2.66667C7.158 2.66667 6.98667 2.738 6.862 2.862L0.862 8.862C0.738 8.98667 0.666667 9.158 0.666667 9.33333C0.666667 9.50867 0.738 9.68 0.862 9.80467L4.862 13.8047C5.11067 14.0533 5.55533 14.0533 5.804 13.8047L11.804 7.80467C11.9287 7.68 12 7.50867 12 7.33333V3.33333C12 3.01133 11.7633 2.73133 11.4487 2.68267C11.3913 2.66933 11.3653 2.66667 11.3333 2.66667H7.33333Z",
    fill: "url(#paint1_linear_399_242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.62 16.0002H8.71337C8.35004 16.0002 7.99604 15.8596 7.74137 15.6129C7.48204 15.3622 7.33337 15.0169 7.33337 14.6669V12.4136C7.33337 12.3249 7.36871 12.2402 7.43071 12.1776L11.804 7.80424C11.9287 7.68024 12 7.5089 12 7.33357V3.33357C12 3.01157 11.7634 2.73157 11.4487 2.6829C11.288 2.65757 11.1694 2.5209 11.1667 2.3589C11.164 2.1969 11.2787 2.05557 11.4387 2.02557C11.872 1.94557 12.3227 2.08024 12.6387 2.38757L15.5907 5.21957C15.8514 5.47157 16 5.8169 16 6.1669V14.6669C16 15.0169 15.8514 15.3622 15.592 15.6129C15.3374 15.8596 14.9834 16.0002 14.62 16.0002ZM8.00004 12.5516V14.6669C8.00004 14.8376 8.07471 15.0082 8.20537 15.1342C8.33604 15.2609 8.52137 15.3336 8.71337 15.3336H14.62C14.812 15.3336 14.9967 15.2609 15.128 15.1342C15.2587 15.0082 15.3334 14.8376 15.3334 14.6669V6.1669C15.3334 5.99624 15.2587 5.82557 15.128 5.69957L12.6667 3.33824V7.33357C12.6667 7.68424 12.524 8.02757 12.276 8.27624L8.00004 12.5516Z",
    fill: "url(#paint2_linear_399_242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 12.5516V14.6669C8.00004 14.8376 8.07471 15.0082 8.20537 15.1342C8.33604 15.2609 8.52137 15.3336 8.71337 15.3336H14.62C14.812 15.3336 14.9967 15.2609 15.128 15.1342C15.2587 15.0082 15.3334 14.8376 15.3334 14.6669V6.1669C15.3334 5.99624 15.2587 5.82557 15.128 5.69957L12.6667 3.33824V7.33357C12.6667 7.68424 12.524 8.02757 12.276 8.27624L8.00004 12.5516Z",
    fill: "url(#paint3_linear_399_242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 5.3335C9.78204 5.3335 9.33337 4.88483 9.33337 4.3335C9.33337 3.78216 9.78204 3.3335 10.3334 3.3335C10.8847 3.3335 11.3334 3.78216 11.3334 4.3335C11.3334 4.88483 10.8847 5.3335 10.3334 5.3335ZM10.3334 4.00016C10.1494 4.00016 10 4.1495 10 4.3335C10 4.5175 10.1494 4.66683 10.3334 4.66683C10.5174 4.66683 10.6667 4.5175 10.6667 4.3335C10.6667 4.1495 10.5174 4.00016 10.3334 4.00016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 4.66667C14.1493 4.66667 14 4.51733 14 4.33333V2.33333C14 1.41467 13.252 0.666667 12.3333 0.666667C11.4147 0.666667 10.6667 1.41467 10.6667 2.33333V3.66667C10.6667 3.85067 10.5173 4 10.3333 4C10.1493 4 10 3.85067 10 3.66667V2.33333C10 1.04667 11.0467 0 12.3333 0C13.62 0 14.6667 1.04667 14.6667 2.33333V4.33333C14.6667 4.51733 14.5173 4.66667 14.3333 4.66667Z",
    fill: "url(#paint4_linear_399_242)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_399_242",
    x1: 6.33333,
    y1: 2,
    x2: 6.33333,
    y2: 14.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_399_242",
    x1: 6.33333,
    y1: 2,
    x2: 6.33333,
    y2: 14.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_399_242",
    x1: 11.6667,
    y1: 2.00293,
    x2: 11.6667,
    y2: 16.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_399_242",
    x1: 11.6667,
    y1: 2.00293,
    x2: 11.6667,
    y2: 16.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_399_242",
    x1: 12.3333,
    y1: 0,
    x2: 12.3333,
    y2: 4.66667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_399_242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingSel);
export default __webpack_public_path__ + "static/media/pricingSel.ffac029463fad6894721083b1f745e69.svg";
export { ForwardRef as ReactComponent };